<div class="container py-5">
  <div class="row align-items-center">
    <div class="col-md-6 text-center text-md-start">
      <h1 class="fw-bold mb-3">{{ 'HOME.HERO.TITLE' | translate }}</h1>
      <p class="lead text-muted mb-4">
        {{ 'HOME.HERO.SUBTITLE' | translate }}
      </p>
      <button matButton="filled" color="accent" (click)="actionVerMas()">
        {{ 'HOME.HERO.BUTTON' | translate }}
      </button>
    </div>
    <div class="col-md-6 text-center">
      <img src="assets/images/inicioNew.png" alt="{{ 'HOME.HERO.IMAGE_ALT' | translate }}" class="img-fluid" />
    </div>
  </div>
</div>

